import React from 'react';

const UsibrasLoader = ({ text = 'Processing...' }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white p-8 rounded-xl shadow-xl flex flex-col items-center">
        <div className="w-12 h-12 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-navy-700 font-medium">{text}</p>
      </div>
    </div>
  );
};

export default UsibrasLoader; 